var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBuilding2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6321_46390)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.11941 45.5316C6.99941 45.2776 4.91441 44.7306 2.94241 43.9116C2.63341 43.7826 2.30641 43.6306 2.13741 43.3406C1.90641 42.9436 2.05641 42.4286 2.30941 42.0456C2.97341 41.0426 4.28041 40.4926 4.65141 39.3486C4.94741 38.4376 4.53441 37.4456 3.98641 36.6606C3.43741 35.8756 2.74041 35.1816 2.35341 34.3056C2.11341 33.7636 2.04441 33.0376 2.50041 32.6596C3.04041 32.2126 3.89641 32.5736 4.53441 32.2796C5.10841 32.0156 5.32341 31.3146 5.39741 30.6866C5.60941 28.8766 5.17741 27.0346 5.41041 25.2276C5.48341 24.6626 5.63141 24.0856 5.99141 23.6446C6.49941 23.0206 7.34141 22.7726 8.14241 22.7026C10.4014 22.5046 12.7314 23.5316 14.1094 25.3326C15.2584 26.8346 15.7294 28.7506 15.9214 30.6316C16.1864 33.2356 15.9624 35.8866 15.2774 38.4116C14.6564 40.6996 13.7324 43.3086 11.6214 44.6346C10.5484 45.3086 9.16841 45.5616 7.98541 45.1076C8.36341 45.2486 8.74141 45.3896 9.11941 45.5316Z",
    fill: "#C9BBDD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6185 11.1633C21.6185 11.1633 20.9559 37.4383 21.6505 42.3503C22.3452 47.2622 21.9343 46.2245 29.7755 46.4941C37.6168 46.7638 57.7695 46.7638 59.2144 46.1564C60.6592 45.549 61.0022 41.8367 60.9344 38.7317C60.8653 35.6267 61.7598 17.4014 61.0713 13.8907C60.3841 10.3812 61.8277 9.09839 52.3356 9.36808C42.8447 9.63777 23.4976 9.61432 23.4976 9.61432C23.4976 9.61432 21.6419 9.53224 21.6185 11.1633Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6184 46.9949C21.6184 46.9949 20.9557 51.6868 21.6508 52.5637C22.3449 53.4406 21.935 53.2561 29.7758 53.303C37.6166 53.3498 57.7692 53.3513 59.2142 53.243C60.6582 53.1346 61.0022 52.4715 60.9342 51.9166C60.8652 51.3618 61.7592 48.1075 61.0722 47.4809C60.3842 46.8544 61.8292 46.6245 52.3374 46.6728C42.8456 46.7212 23.4997 46.7168 23.4997 46.7168C23.4997 46.7168 21.6417 46.7036 21.6184 46.9949Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.038 14.9279C28.038 14.9279 27.9494 18.6816 28.0428 19.3832C28.1349 20.0848 28.0806 19.9368 29.1264 19.9753C30.1722 20.0138 32.8582 20.0138 33.0508 19.9272C33.2434 19.8405 33.2895 19.3098 33.28 18.8669C33.2706 18.4228 33.3899 15.8197 33.2989 15.3179C33.2068 14.816 33.3994 14.6331 32.1338 14.6716C30.8682 14.7101 28.2885 14.7065 28.2885 14.7065C28.2885 14.7065 28.0416 14.6957 28.038 14.9279Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6668 15.0797C38.6668 15.0797 38.7066 18.7616 38.8215 19.446C38.9374 20.1305 38.8777 19.9865 39.9144 19.9889C40.9512 19.99 43.6128 19.8968 43.8014 19.8048C43.99 19.7127 44.017 19.1911 43.9924 18.7568C43.9678 18.3226 43.9982 15.7665 43.8905 15.2779C43.7827 14.7894 43.9678 14.6029 42.7143 14.6855C41.462 14.767 38.9058 14.8531 38.9058 14.8531C38.9058 14.8531 38.6621 14.8507 38.6668 15.0797Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3333 15.0797C49.3333 15.0797 49.3731 18.7616 49.488 19.446C49.6039 20.1305 49.5442 19.9865 50.5809 19.9889C51.6177 19.99 54.2793 19.8968 54.4679 19.8048C54.6566 19.7127 54.6835 19.1911 54.6589 18.7568C54.6343 18.3226 54.6648 15.7665 54.557 15.2779C54.4492 14.7894 54.6343 14.6029 53.3808 14.6855C52.1285 14.767 49.5723 14.8531 49.5723 14.8531C49.5723 14.8531 49.3286 14.8507 49.3333 15.0797Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3903 31.0586C29.3903 31.0586 29.2574 36.689 29.3974 37.7415C29.5374 38.7939 29.4541 38.5719 31.0228 38.6297C32.5915 38.6874 36.6205 38.6874 36.9094 38.5574C37.1983 38.4275 37.2675 37.6314 37.2533 36.9671C37.2391 36.3027 37.4181 32.3962 37.2816 31.6435C37.1452 30.8907 37.4323 30.6163 35.5339 30.6741C33.6355 30.7318 29.7661 30.7264 29.7661 30.7264C29.7661 30.7264 29.3956 30.7102 29.3903 31.0586Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.745 45.297C46.7194 45.2922 46.6938 45.2869 46.6682 45.2815C46.0066 45.1356 45.5098 44.6991 45.1568 44.2328C44.4643 43.3181 44.1918 42.2415 44.0759 41.1791C43.8975 39.5421 44.0639 37.8943 44.2626 36.2584C44.4643 34.6006 44.7029 32.9332 45.3231 31.342C45.5143 30.8507 45.7446 30.3582 45.7597 29.8437C45.765 29.671 45.7672 29.4643 45.9516 29.3726C46.1044 29.297 46.3046 29.3441 46.4702 29.4012C47.8943 29.8943 48.8947 30.9579 49.4848 32.0953C50.23 33.5322 50.4106 35.1079 50.5416 36.6574C50.6688 38.1599 50.7523 39.676 50.5205 41.1749C50.3165 42.494 49.9545 44.1792 48.4664 44.9939C47.9681 45.266 47.3321 45.4042 46.745 45.297Z",
    fill: "#FA532E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4189 30.1183C44.4189 30.1183 44.2198 41.379 44.4288 43.4845C44.6367 45.5899 44.5139 45.1448 46.8661 45.2598C49.2183 45.3749 55.2636 45.3749 55.6974 45.1148C56.1312 44.8547 56.2342 43.2627 56.2134 41.9325C56.1926 40.6022 56.461 32.7905 56.255 31.2869C56.049 29.7832 56.4818 29.2331 53.6345 29.3481C50.7871 29.4631 44.9834 29.4548 44.9834 29.4548C44.9834 29.4548 44.4268 29.4181 44.4189 30.1183Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 24.8674C22.6667 24.8674 38.6382 23.3735 42.95 24.3068C47.2618 25.2401 60.0001 25.3333 60.0001 25.3333",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 53.3334H4",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98535 27.1027L10.2584 52.4277",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04639 29.8276L9.91339 31.9936",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0054 34.5337L10.1184 35.6757",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27026 41.4067L10.0663 43.0097",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41423 45.7987C8.41423 45.7987 1.85423 46.3157 1.54423 43.8877C1.23423 41.4597 5.00523 40.6857 5.16023 39.6527C5.31523 38.6197 0.253232 36.5537 1.54423 34.4357C2.83523 32.3177 4.54023 33.4547 3.55823 29.5807C2.57623 25.7067 8.53423 19.6597 12.7092 21.9597C16.8842 24.2597 13.0622 27.8237 14.0432 29.6317C15.0242 31.4397 19.5182 34.4347 16.3672 37.9987C13.2162 41.5627 15.3342 45.0227 13.8362 45.4367C12.3382 45.8507 8.41423 45.7987 8.41423 45.7987Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6321_46390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuilding2);
export default __webpack_public_path__ + "static/media/icon-building-2.4245e733919fb0ff14c5759251fa61e3.svg";
export { ForwardRef as ReactComponent };